import { render, staticRenderFns } from "./botonesEnviarCorreo.vue?vue&type=template&id=7c8821c4&"
import script from "./botonesEnviarCorreo.vue?vue&type=script&lang=js&"
export * from "./botonesEnviarCorreo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports